import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JumbotronSharedComponent } from './jumbotron.component';

@NgModule({
    declarations: [
        JumbotronSharedComponent,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        JumbotronSharedComponent
    ]
})
export class JumbotronSharedModule {}
